import { Inject, forwardRef } from "@angular/core";
import { Observable } from "rxjs";
import { Customer, Location, Organization, Partner } from "../../model";
import { Tag } from "../../model/tag";

export abstract class AbstractContextService {
    abstract getCurrentCustomer(): Customer;
    abstract getCurrentLocation(): Location;
    abstract getCurrentPartner(): Partner;
    abstract getCurrentOrganization(): Organization;
    abstract initTags(): Promise<void>;
    abstract getTags(): string[];
    abstract getTagObjects(): Tag[];
    abstract getCustomerTags(): string[];
    abstract getCustomerTagObjects(): Tag[];
    abstract getLocationTags(): string[];
    abstract getLocationTagObjects(): Tag[];
    abstract getPartnerTags(): string[];
    abstract getPartnerTagObjects(): Tag[];
    abstract getTagsSubject(): Observable<Tag[]>;
}